import type { IconData } from '@stacksjs/iconify-core'

export const refrigerator: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M36.44 3.494c2.205.218 3.826 1.863 4.023 4.07C40.724 10.508 41 15.6 41 24s-.276 13.493-.537 16.435c-.197 2.208-1.818 3.853-4.023 4.071c-2.504.248-6.488.494-12.44.494s-9.936-.246-12.44-.494c-2.205-.218-3.826-1.863-4.022-4.07C7.276 37.493 7 32.4 7 24s.276-13.493.538-16.436c.196-2.207 1.817-3.852 4.022-4.07C14.064 3.246 18.048 3 24 3s9.936.246 12.44.494M41 24H7m8-12v4m0 16v4\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default refrigerator
